import { render, staticRenderFns } from "./GoodsSearchAndSelectionPanel.vue?vue&type=template&id=0cf61179&"
import script from "./GoodsSearchAndSelectionPanel.vue?vue&type=script&lang=js&"
export * from "./GoodsSearchAndSelectionPanel.vue?vue&type=script&lang=js&"
import style0 from "./GoodsSearchAndSelectionPanel.vue?vue&type=style&index=0&id=0cf61179&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports